import type { FC } from "react";

import {
  INLINE_DEFAULTS,
  INLINE_RESPONSIVE_GAP_CLASS_MAP,
  type TInlineProps,
} from "@/ui/components/layout/Inline";
import { cn, makeBreakpointClassName } from "@/ui/lib/utils";

export const Inline: FC<TInlineProps> = (
  {
    tag: Tag = INLINE_DEFAULTS.tag,
    gap = INLINE_DEFAULTS.gap,
    "data-component": component = INLINE_DEFAULTS["data-component"],
    className,
    children,
    ...props
  },
) => (
  <Tag
    {...props}
    data-component={component}
    className={cn(
      "flex flex-row",
      makeBreakpointClassName(
        gap,
        INLINE_RESPONSIVE_GAP_CLASS_MAP,
        INLINE_DEFAULTS.gap,
      ),
      className,
    )}
  >
    { children }
  </Tag>
);

Inline.displayName = "Inline";
